export default "__VITE_ASSET__BJvqELSN__"